import { useState } from "react"
import { useHistory } from "react-router-dom"

import * as Sentry from "@sentry/react"

import Grid from "@material-ui/core/Grid"

import { Form, Field, FormElement } from "@progress/kendo-react-form"
import { Input, TextArea, Switch } from "@progress/kendo-react-inputs"
import { Button } from "@progress/kendo-react-buttons"
import { Label } from "@progress/kendo-react-labels"

import { feedbackSend } from "../../Shared/Services/ApiService"

function SentryForm(props) {
  const history = useHistory()

  const {
    backgroundProcessor,
    notificationCreate,
    confirmDialogCreate,
    user,
    eventId,
    checkAppStatus,
  } = props

  const [isIssue, setIsIssue] = useState(false)

  const FormTextArea = (fieldRenderProps) => {
    return <TextArea {...fieldRenderProps} rows={4} />
  }

  const FeedbackForm = () => (
    <Grid container direction="column" item>
      <Grid item style={{ paddingBottom: "2rem" }}>
        {eventId && (
          <p>
            Look at me. No plans, no backup, no weapons worth a damn. Oh, and
            something else I don&#39;t have: anything to lose. So, if you&#39;re
            sitting up there with your silly little spaceships and your silly little
            guns and you&#39;ve any plans on taking the Pandorica tonight; just
            remember who&#39;s standing in your way. Remember every black day I ever
            stopped you and then, and then, do the smart thing. Let somebody else try
            first. Father Christmas. Santa Claus. Or, as I&#39;ve always known him,
            Jeff. No. You&#39;re too short and bossy, and your nose is all funny.
          </p>
        )}
        {!eventId && (
          <p>
            Look at me. No plans, no backup, no weapons worth a damn. Oh, and
            something else I don&#39;t have: anything to lose. So, if you&#39;re
            sitting up there with your silly little spaceships and your silly little
            guns and you&#39;ve any plans on taking the Pandorica tonight; just
            remember who&#39;s standing in your way. Remember every black day I ever
            stopped you and then, and then, do the smart thing. Let somebody else try
            first. Father Christmas. Santa Claus. Or, as I&#39;ve always known him,
            Jeff. No. You&#39;re too short and bossy, and your nose is all funny.
          </p>
        )}
      </Grid>

      <Grid item>
        <FormElement>
          <Grid container direction="column">
            {!eventId && (
              <Grid item style={{ paddingBottom: "1rem" }}>
                <Label editorId="isIssue">Found an issue?</Label>
                <Switch
                  id="isIssue"
                  onChange={(event) => {
                    setIsIssue(event.target.value)
                  }}
                  checked={isIssue}
                />
              </Grid>
            )}

            <Grid item style={{ paddingBottom: "1rem" }}>
              <Field
                id="fullName"
                name="fullName"
                label="Full name"
                component={Input}
                validator={(value) => {
                  return value ? "" : "Full name is invalid."
                }}
              />
            </Grid>

            <Grid item style={{ paddingBottom: "2rem" }}>
              <Field
                id="email"
                name="email"
                label="Email"
                type="email"
                component={Input}
                validator={(value) => {
                  return new RegExp(/\S+@\S+\.\S+/).test(value)
                    ? ""
                    : "Email is invalid."
                }}
              />
            </Grid>

            <Grid item style={{ paddingBottom: "2rem" }}>
              <Grid container item direction="column">
                <Grid item>
                  <Field
                    id="comments"
                    name="comments"
                    component={FormTextArea}
                    validator={(value) => {
                      return value ? "" : "Comments are invalid."
                    }}
                  />
                </Grid>

                <Grid item>
                  {/* prettier-ignore */}
                  <p style={{ fontSize: '0.75rem' }}>
                                        {eventId
                                            ? 'Explain in a few words what were your last actions'
                                            : isIssue
                                                ? 'Explain in a few words the issue you have encountered'
                                                : 'Explain in a few words the feedback you would like to provide'}
                                    </p>
                </Grid>
              </Grid>
            </Grid>

            <Grid container item wrap="nowrap">
              {eventId && (
                <Grid item>
                  <Button
                    type="button"
                    iconClass="fas fa-ban"
                    look="flat"
                    disabled={backgroundProcessor?.tasks}
                    onClick={() => {
                      history.push("/")
                    }}
                  >
                    No
                  </Button>
                </Grid>
              )}

              <Grid container item justifyContent="flex-end">
                <Grid item>
                  <Button
                    type="submit"
                    iconClass="fas fa-paper-plane"
                    primary
                    disabled={backgroundProcessor?.tasks}
                  >
                    Send feedback
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </FormElement>
      </Grid>
    </Grid>
  )

  const formOnSubmitHandler = async (form) => {
    const { fullName, email, comments } = form

    if (!fullName || typeof fullName !== "string") return
    if (!email || typeof email !== "string") return
    if (!comments || typeof comments !== "string") return

    confirmDialogCreate({
      title: "Feedback",
      content: "Send your feedback for our team to analyse?",
      onConfirm: async () => {
        try {
          backgroundProcessor?.add()

          if (!(await checkAppStatus())) return

          if (!eventId) {
            Sentry.captureMessage(
              `${user?.fullName} feedback ${new Date().toISOString()}`
            )
          }

          await feedbackSend({ ...form, eventId: eventId || Sentry.lastEventId() })

          history.push("/")

          notificationCreate({
            severity: "success",
            message: "Your feedback was sent successfully!",
          })

          backgroundProcessor?.remove()
        } catch (error) {
          backgroundProcessor?.remove()

          Sentry.captureException(error, {
            tags: { context: "feedback", noFallback: true },
          })

          notificationCreate({
            severity: "error",
            message:
              "Apologies, we could not send your feedback. Our team has been notified about the issue. " +
              "Please, wait a moment and try again.",
          })
        }
      },
    })
  }

  return (
    <Form
      initialValues={{
        fullName: user?.fullName || "",
        email: user?.email || "",
      }}
      onSubmit={formOnSubmitHandler}
      render={FeedbackForm}
    />
  )
}

export default SentryForm
